// extracted by mini-css-extract-plugin
module.exports = {"registry":"Registry_registry__dAi9P","title":"Registry_title__RA27b","subtitle":"Registry_subtitle___05Rg"};